export default __webpack_public_path__ + "static/media/sadFace.1ebb1545.svg";